import React, { useEffect, useState } from 'react';
import { getBusinessStatus } from '../lib/businessHours';

export const BusinessStatus = () => {
  const [status, setStatus] = useState(() => getBusinessStatus());
  useEffect(() => {
    const update = () => setStatus(getBusinessStatus());
    const timer = window.setInterval(update, 1000);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', update);
    };
  }, []);
  return (
    <span className={`business-status ${status.isOpen ? 'is-open' : ''}`} data-testid="business-status" role="status"
      title={`${status.isOpen ? `Both shops open until ${status.closesAt}` : 'Both shops closed'} · America/Denver · Mon–Fri 8 AM–6 PM, Sat 8 AM–2 PM, Sun closed`}>
      <span className="status-dot" aria-hidden="true" />{status.label}
    </span>
  );
};